import "./AddExam.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddExamViewModel from "./AddExamViewModel";

const AddExam = () => {
  const {
    RegisterExam,
    AddExam,
    setAddExam,
    ExamNameError,
    ExamDescriptionError,
    ExamTotalMarksError,
    ExamDateError,
    ExamStartTimeError,
    ExamEndTimeError,
    FormDisabled,
  } = AddExamViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-exam-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Add Exam</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link>Exams Listing</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Exam</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Exam Information</span>
                        </h5>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>Exam Name</label>
                          <input
                            type="text"
                            className={`form-control ${
                              ExamNameError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamName: e.target.value,
                              });
                            }}
                            value={AddExam.ExamName}
                            disabled={FormDisabled}
                          />
                          {ExamNameError === true && (
                            <span className="error-message-text">
                              Exam name is required and can not be less than 3
                              characters
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>Exam Description</label>
                          <input
                            type="text"
                            className={`form-control ${
                              ExamDescriptionError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamDescription: e.target.value,
                              });
                            }}
                            value={AddExam.ExamDescription}
                            disabled={FormDisabled}
                          />
                          {ExamDescriptionError === true && (
                            <span className="error-message-text">
                              Exam description is required and can not be less
                              than 3 characters
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>Exam Total Marks</label>
                          <input
                            type="text"
                            className={`form-control ${
                              ExamTotalMarksError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamTotalMarks: e.target.value.trim(),
                              });
                            }}
                            value={AddExam.ExamTotalMarks}
                            disabled={FormDisabled}
                          />
                          {ExamTotalMarksError === true && (
                            <span className="error-message-text">
                              Exam total marks are required
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>Event Date</label>
                          <input
                            type="date"
                            className={`form-control ${
                              ExamDateError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamDate: e.target.value,
                              });
                            }}
                            value={AddExam.ExamDate}
                            disabled={FormDisabled}
                          />

                          {ExamDateError === true && (
                            <span className="error-message-text">
                              Exam date is required.
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>Start Time</label>
                          <input
                            type="time"
                            className={`form-control ${
                              ExamStartTimeError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamStartTime: e.target.value,
                              });
                            }}
                            value={AddExam.ExamStartTime}
                            disabled={FormDisabled}
                          />
                          {ExamStartTimeError === true && (
                            <span className="error-message-text">
                              Exam start time is required.
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label>End Time</label>
                          <input
                            type="time"
                            className={`form-control ${
                              ExamEndTimeError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddExam({
                                ...AddExam,
                                ExamEndTime: e.target.value,
                              });
                            }}
                            value={AddExam.ExamEndTime}
                            disabled={FormDisabled}
                          />
                          {ExamEndTimeError === true && (
                            <span className="error-message-text">
                              Exam end time is required.
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            RegisterExam();
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddExam;
